import React from 'react';
import { Link } from 'react-router-dom';

// Icons 
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';

const Footer = () => {

  function aiRenderSocials(platform) {
    if(platform === "youtube") {
      window.open("https://www.youtube.com/channel/UCopoUhBWAw6lzD3lpV2zg2A");
    } 
    else if(platform === "facebook") {
      window.open("https://www.facebook.com/aiRenderTechnology");
    } 
    else if(platform === "linkedin") {
      window.open("https://www.linkedin.com/company/airendertechnology/");
    }
    else if(platform === "instagram") {
      window.open("https://www.instagram.com/airender_technology/");
    } 
    else if(platform === "twitter") {
      window.open("https://twitter.com/aiRenderTech");
    }
  }

    return(
      <div className='footer-section'>
        <div className='footer-social-links'>
          <div className='footer-linkedin-links' onClick={()=>aiRenderSocials("linkedin")}>
            <LinkedInIcon />
          </div>
          <div className='footer-youtube-links' onClick={()=>aiRenderSocials("youtube")}>
            <YouTubeIcon />
          </div>
          <div className='footer-facebook-links' onClick={()=>aiRenderSocials("facebook")}>
            <FacebookIcon />
          </div>
          <div className='footer-instagram-links' onClick={()=>aiRenderSocials("instagram")}>
            <InstagramIcon />
          </div>
          <div className='footer-twitter-links' onClick={()=>aiRenderSocials("twitter")}>
            <TwitterIcon />
          </div>
        </div>
        <div className='footer-content'>
          <div className='footer-address'>
            aiRender Technology Private Limited, H-005, Vijetha Elysium, Hagadur Road, Whitefield, Bangalore, Karnataka - 560066
          </div>
          <div className='footer-terms-privacy'>
            {/* <div className='footer-terms-conditions'>
              Terms and Conditions
            </div> 
            <div className='footer-privacy-policy'>
              Privacy Policy
            </div> */}
            <Link to='/TermsConditions' className="footer-terms-conditions">
              Terms and Conditions
            </Link>
            <Link to='/PrivacyPolicy' className="footer-privacy-policy">
              Privacy Policy
            </Link>
          </div>
          <div className='footer-Copyrights'>
            Copyright © 2021 aiRender® Technology Pvt Ltd. All rights reserved.
          </div>
        </div>
      </div>
    )
}

export default Footer;